module.exports = __webpack_public_path__ + "static/media/4_DeviceMockups-fr.ec3bc444.png";